import { logError } from '#utils';
import React from 'react';

type Props = {
  scope?: string;
  children?: React.ReactNode;
};

// eslint-disable-next-line modernloop/validate-component-definition.cjs
export class SilentErrorBoundary extends React.Component<Props> {
  componentDidCatch(error: Error): void {
    logError(error, { scope: this.props.scope });
  }

  // The render method is not called if there is an error
  render() {
    return this.props.children;
  }
}
